import { type ReduxStateShared } from '~shared/types';

export const getViewedNotices = (state: ReduxStateShared) => state.notices.viewed;
